import React from 'react';
import { Typography, colors } from '@material-ui/core';

import useIsUpMD from 'hooks/media_query/useIsUpMD';

const Title = ({ children }) => {
  const isUpMD = useIsUpMD();

  return (
    <Typography
      variant={isUpMD ? 'h3' : 'h4'}
      style={{ color: colors.red[400], fontFamily: 'Pacifico,cursive' }}
    >
      <b>{children}</b>
    </Typography>
  );
};

export default Title;
